import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, updateProfile } from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyD33RYqkPahgPdyy65fw1dnBCCi7_ouESE",
    authDomain: "travel-825fd.firebaseapp.com",
    projectId: "travel-825fd",
    storageBucket: "travel-825fd.firebasestorage.app",
    messagingSenderId: "80107490360",
    appId: "1:80107490360:web:4c3e1de46b20f81600eacd",
    measurementId: "G-B9M9JYY4EX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);

// Google Auth Provider with additional scopes
export const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('https://www.googleapis.com/auth/userinfo.email');
googleProvider.addScope('https://www.googleapis.com/auth/userinfo.profile');
googleProvider.setCustomParameters({
    prompt: 'select_account'
});

export default app;